<template>
	<v-slide-item>
		<v-btn	class="customVBtn"
				:block="$_tmSldItm_styleMenuButtonBlock"
				:color="$_tmSldItm_styleMenuButtonColor"
				:dark="$_tmSldItm_styleMenuButtonDark"
				:depressed="$_tmSldItm_styleMenuButtonDepressed"
				:elevation="$_tmSldItm_styleMenuButtonElevation"
				:large="$_tmSldItm_styleMenuButtonLarge"
				:light="$_tmSldItm_styleMenuButtonLight"
				:outlined="$_tmSldItm_styleMenuButtonOutlined"
				:rounded="$_tmSldItm_styleMenuButtonRounded"
				:small="$_tmSldItm_styleMenuButtonSmall"
				:text="$_tmSldItm_styleMenuButtonFlat"
				@click="$_tmSldItm_toggleTabs(contentKey)">
			<v-row no-gutters align="center">
				<v-col class="center">
					<v-icon	:color="contents[contentKey].iconColor"
							v-text="contents[contentKey].icon || 'arrow_drop_down'" />
				</v-col>
				<template v-if="!isFalse($_tmSldItm_langContentTitle(contents[contentKey]))">
					<v-col class="ml-2 center">
						<span	class="overline"
								v-html="$_tmSldItm_langContentTitle(contents[contentKey])" />
					</v-col>
				</template>
				<template v-if="debugMode">
					<v-col class="ml-2" cols="auto">
						<debugger-order-alert :order="contents[contentKey].order" />
					</v-col>
				</template>
			</v-row>
		</v-btn>
	</v-slide-item>
</template>

<script>
	export default {
		name: 'TabMenuSlideItem',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			// lang
			$_tmSldItm_langContentTitle() {
				const self_ = this;
				return contentVals => {
					if(self_.isFalse(contentVals.title)) { return null }
					return self_.getLangsVal(contentVals.title)
				}
			},
			// style
			$_tmSldItm_styleMenuButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'menuButton')
			},
			$_tmSldItm_styleMenuButtonBlock() {
				const self_ = this;
				const button_ = self_.$_tmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_tmSldItm_styleMenuButtonColor() {
				const self_ = this;
				const button_ =self_.$_tmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_tmSldItm_styleMenuButtonDark() {
				const self_ = this;
				const button_ = self_.$_tmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_tmSldItm_styleMenuButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_tmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_tmSldItm_styleMenuButtonElevation() {
				const self_ = this;
				const button_ = self_.$_tmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_tmSldItm_styleMenuButtonFlat() {
				const self_ = this;
				const button_ = self_.$_tmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_tmSldItm_styleMenuButtonLarge() {
				const self_ = this;
				const button_ = self_.$_tmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_tmSldItm_styleMenuButtonLight() {
				const self_ = this;
				const button_ = self_.$_tmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_tmSldItm_styleMenuButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_tmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_tmSldItm_styleMenuButtonRounded() {
				const self_ = this;
				const button_ = self_.$_tmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_tmSldItm_styleMenuButtonSmall() {
				const self_ = this;
				const button_ = self_.$_tmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			}
		},
		methods: {
			$_tmSldItm_toggleTabs(menu) {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				const toolbar_ = self_.getComponentState('toolbar')
				const showTabMenu_ = self_.getComponentState('showToolbarTabs')

				if(self_.isFalse(showTabMenu_)) {
					toolbar_.menu = menu;
					self_.setComponentState('toolbar', toolbar_)
					self_.setComponentState('showToolbarTabs', true)
				} else {
					if(toolbar_.menu != menu) {
						toolbar_.menu = menu;
						self_.setComponentState('toolbar', toolbar_)
					} else {
						self_.setComponentState('showToolbarTabs', false)
					}
				}

				vuetify_.goTo('#_app_top')
			}
		}
	}
</script>

<style scoped>
</style>
